import CustomSearchDropdown from 'components/common/CustomSearchDropdown/ver2';
import {
  getOccupationOptions,
  getPrevOccupationOptions,
} from 'components/common/func';
import {
  EDIT_PROFILE_OCCUPATION_FIELDS,
  EDIT_PROFILE_OCCUPATION_NAME,
  EDIT_PROFILE_PREVIOUS_EMPLOYED_NAME,
} from 'constants';
import { CONFIG_OCCUPATION_EXTRAS } from 'constants/common';
import { Fade } from 'helpers/animation';
import useStore from 'hooks/useStore';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

const CustomOccupationDropdown = ({
  information,
  validation,
  setInformation,
  setValidation,
}) => {
  const { state } = useStore();
  const { configOccupation } = state;

  const [occupations, setOccupations] = useState(null);

  useEffect(() => {
    setOccupations({
      [EDIT_PROFILE_OCCUPATION_NAME]: getOccupationOptions(configOccupation),
      [EDIT_PROFILE_PREVIOUS_EMPLOYED_NAME]: getPrevOccupationOptions(
        information[EDIT_PROFILE_OCCUPATION_NAME]?.key,
        configOccupation
      ),
    });
  }, [configOccupation, information]);

  const isPreviousOccupationField = (field) =>
    field.name === EDIT_PROFILE_PREVIOUS_EMPLOYED_NAME;

  const isHidePreviousOccupation = (field) =>
    isPreviousOccupationField(field) &&
    !CONFIG_OCCUPATION_EXTRAS?.find(
      (occupation) =>
        occupation === information[EDIT_PROFILE_OCCUPATION_NAME]?.key
    );

  return (
    <>
      {EDIT_PROFILE_OCCUPATION_FIELDS.map((field) => (
        <AddressDropdownStyled
          key={field.name}
          $isHidden={isHidePreviousOccupation(field)}
        >
          <CustomSearchDropdown
            field={field}
            data={occupations?.[field.name]}
            keyFind="key"
            keyTranslate="value"
            noResultText="form_text_no_result"
            information={information}
            setInformation={setInformation}
            validation={validation}
            setValidation={setValidation}
          />
        </AddressDropdownStyled>
      ))}
    </>
  );
};

const AddressDropdownStyled = styled.div`
  position: relative;
  width: 100%;
  ${Fade};
  display: ${(props) => props.$isHidden && 'none'};
`;

export default CustomOccupationDropdown;
